import { render, staticRenderFns } from "./HistoryMapClassic.vue?vue&type=template&id=db39b97a&"
import script from "./HistoryMapClassic.vue?vue&type=script&lang=js&"
export * from "./HistoryMapClassic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports